import type { ApprovalChain } from '../approval-chain.model';

export const DEED_TRANSFER_BOND_CHAIN: ApprovalChain = {
  id: 'deed-transfer-bond',
  label: 'Deed of Transfer with Bond',
  applicationTypes: ['DEED_TRANSFER_BOND'],
  steps: [
    {
      role: 'FIRST_BANK_USER',
      action: 'Recommend',
      from: ['LOCAL_GOVERNMENT_APPROVED', 'RESUBMITTED', 'SUBMITTED', 'PENDING', 'MINISTRY_OF_LANDS_DIRECTOR_LEGAL_APPROVED'],
      to: 'FIRST_BANK_USER_APPROVED',
    },
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['FIRST_BANK_USER_APPROVED', 'SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
